/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:25fe35df-68bd-415d-9697-7a82fc54d87a",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_zKpRSDYEZ",
    "aws_user_pools_web_client_id": "50g09m2uqq7doaa8ck28g21ml6",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://kwacd00hd3.execute-api.eu-central-1.amazonaws.com/dashboard",
            "region": "eu-central-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://ok3t66liprahzmo5n4zyngnly4.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
